import React, { useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import { connect } from "react-redux";
import { State } from "../../../../reducers/reducer";
import Select, { SelectProps } from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import { updateConstructionDieselVolumes } from "../../../../reducers/sustainability/allocation/constructionDieselVolumes/index";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textfield: {
      color: theme.palette.primary.main,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),

      padding: 0,
    },
    greyText: {
      color: theme.palette.action.disabled,
    },
  })
);

interface Props {
  type: string;
  displayEmpty?: boolean;
  className?: any;
}

interface StateProps {
  data: any;
  taxYearId: number;
  dispatch?: any; // fix warning
  emptyMenuItem?: React.ReactNode;
}

const mapStateToProps = (state: State, ownProps: Props) => ({
  data: state.sustainability.allocation.constructionDieselVolumes.data,
  taxYearId: state.sustainability.main.activePeriod
    ? state.sustainability.main.activePeriod.id
    : 0,
});

interface DispatchProps {
  updateConstructionDieselVolumes: (value: number, type: string) => any;
}

const mapDispatchToProps = {
  updateConstructionDieselVolumes,
};

const ConstructionDieselVolumeTextField = ({
  data,
  taxYearId,
  updateConstructionDieselVolumes,
  type = "",
  className,
  dispatch,
  emptyMenuItem,
  ...rest
}: SelectProps & StateProps & DispatchProps) => {
  const [value, setValue] = useState<string>(data[type]);
  const classes = useStyles();

  return (
    <TextField
      className={classes.textfield}
      value={value}
      onChange={(e) => {
        setValue(e.target.value);
      }}
      onBlur={(e) => {
        let newVal = e.target.value ? e.target.value : "0";
        setValue(newVal);
        updateConstructionDieselVolumes(parseFloat(newVal), type);
      }}
      variant="outlined"
      type="number"
      inputProps={{
        style: {
          textAlign: "right",
          padding: "6px 0px 6px 0px",
          margin: 0,
          fontSize: "13px",
        },
      }}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConstructionDieselVolumeTextField);
